<template>
    <Head title="Welcome"/>

    <div
        class="relative flex items-top justify-center min-h-screen bg-gray-100 dark:bg-gray-900 sm:items-center sm:pt-0">
        <div v-if="canLogin" class="hidden fixed top-0 right-0 px-6 py-4 sm:block">
            <Link v-if="$page.props.user" :href="route('dashboard')"
                  class="text-sm text-gray-700 dark:text-gray-400 underline">
                Dashboard
            </Link>

            <template v-else>
                <Link :href="route('login')" class="text-sm text-gray-700 dark:text-gray-400 underline">
                    Log in
                </Link>

                <Link v-if="canRegister" :href="route('register')"
                      class="ml-4 text-sm text-gray-700 dark:text-gray-400 underline">
                    Register
                </Link>
            </template>
        </div>

        <div class="max-w-6xl mx-auto sm:px-6 lg:px-8 w-full">
            <div class="flex justify-center w-full pt-8 sm:justify-start sm:pt-0 beecoded-logo">
                <svg version="1.1" id="Isolation_Mode" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                     y="0px" viewBox="0 0 255.1 141.7" style="enable-background:new 0 0 255.1 141.7;"
                     xml:space="preserve">
                    <g>
                        <g>
                            <g>
                                <polygon points="127.6,76 125,73.1 124.2,73.1 127.3,76.7 127.8,76.7 131,73.1 130.1,73.1 			"/>
                            </g>
                            <g>
                                <g>
                                    <rect x="123.8" y="67.3" width="7.6" height="0.7"/>
                                </g>
                                <g>
                                    <rect x="123.8" y="63.3" width="7.6" height="0.7"/>
                                </g>
                            </g>
                            <g>
                                <g>
                                    <rect x="127.1" y="52.3" width="0.9" height="0.9"/>
                                </g>
                                <g>
                                    <rect x="127.1" y="54.8" width="0.9" height="0.9"/>
                                </g>
                            </g>
                            <g>
                                <g>
                                    <g>
                                        <polygon points="124,33.2 123.3,33.2 125.4,38.6 126.1,38.6 					"/>
                                    </g>
                                    <g>
                                        <polygon
                                            points="124.7,41.5 124.7,40.8 122.4,40.8 122.4,48 124.7,48 124.7,47.4 123.1,47.4 123.1,41.5 					"/>
                                    </g>
                                    <g>
                                        <path d="M120.1,65.6c0-3.9,2.2-5.5,2.3-5.5l0,0h-1c-0.8,0.8-2,2.5-2,5.5c0,3,1.2,4.7,2,5.5h1C122.3,71.1,120.1,69.5,120.1,65.6
                                            z"/>
                                    </g>
                                    <g>
                                        <path d="M124.1,51.1c0.1-0.1,0.3-0.1,0.5-0.1h0.2v-0.7h-0.2c-0.3,0-0.5,0.1-0.8,0.2c-0.5,0.3-0.8,0.7-0.8,1.2
                                            c0,0.1,0,0.2,0,0.3c0,0.5,0,1.3-0.2,1.5c0,0-0.1,0.1-0.2,0.1h-0.3v0.7h0.3c0.1,0,0.2,0,0.2,0.1c0.2,0.3,0.2,1,0.2,1.5
                                            c0,0.1,0,0.2,0,0.3c0,0.5,0.3,0.9,0.8,1.2c0.2,0.1,0.5,0.2,0.8,0.2h0.2V57h-0.2c-0.2,0-0.3,0-0.5-0.1c-0.3-0.2-0.5-0.4-0.5-0.7
                                            c0-0.1,0-0.2,0-0.3c0-0.7,0-1.5-0.4-1.9c0.4-0.5,0.4-1.3,0.4-1.9c0-0.1,0-0.2,0-0.3C123.6,51.5,123.7,51.3,124.1,51.1z"/>
                                    </g>
                                    <g>
                                        <polygon
                                            points="107.8,53.8 118.2,48.9 118.2,48.2 106.9,53.5 106.9,54.1 118.2,59.3 118.2,58.6 					"/>
                                    </g>
                                    <g>
                                        <polygon points="118.4,52.1 118.2,52.1 117.8,52.1 117.8,53.7 116.2,53.7 116.2,54.3 117.8,54.3 117.8,55.9 118.2,55.9
                                            118.4,55.9 118.4,54.3 120,54.3 120,53.7 118.4,53.7 					"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <polygon points="129,38.6 129.7,38.6 131.8,33.2 131.1,33.2 					"/>
                                    </g>
                                    <g>
                                        <polygon
                                            points="130.5,47.4 130.5,48 132.8,48 132.8,40.8 130.5,40.8 130.5,41.5 132.1,41.5 132.1,47.4 					"/>
                                    </g>
                                    <g>
                                        <path
                                            d="M135.7,65.6c0-3-1.2-4.7-2-5.5h-1c0.1,0.1,2.3,1.6,2.3,5.5s-2.2,5.5-2.3,5.5h1C134.5,70.3,135.7,68.6,135.7,65.6z"/>
                                    </g>
                                    <g>
                                        <polygon
                                            points="136.9,48.2 136.9,48.9 147.4,53.8 136.9,58.6 136.9,59.3 148.3,54.1 148.3,53.5 					"/>
                                    </g>
                                    <g>
                                        <path d="M132.7,54.3h0.3v-0.7h-0.3c-0.1,0-0.2,0-0.2-0.1c-0.2-0.3-0.2-1-0.2-1.5c0-0.1,0-0.2,0-0.3c0-0.5-0.3-0.9-0.8-1.2
                                            c-0.2-0.1-0.5-0.2-0.8-0.2h-0.2V51h0.2c0.2,0,0.3,0,0.5,0.1c0.3,0.2,0.5,0.4,0.5,0.7c0,0.1,0,0.2,0,0.3c0,0.7,0,1.5,0.4,1.9
                                            c-0.4,0.5-0.4,1.3-0.4,1.9c0,0.1,0,0.2,0,0.3c0,0.3-0.2,0.5-0.5,0.7c-0.1,0.1-0.3,0.1-0.5,0.1h-0.2v0.7h0.2
                                            c0.3,0,0.5-0.1,0.8-0.2c0.5-0.3,0.8-0.7,0.8-1.2c0-0.1,0-0.2,0-0.3c0-0.5,0-1.3,0.2-1.5C132.5,54.4,132.6,54.3,132.7,54.3z"/>
                                    </g>
                                    <g>
                                        <polygon points="136.8,55.9 136.9,55.9 137.4,55.9 137.4,54.3 139,54.3 139,53.7 137.4,53.7 137.4,52.1 136.9,52.1 136.8,52.1
                                            136.8,53.7 135.2,53.7 135.2,54.3 136.8,54.3 					"/>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g>
                            <path d="M76.5,96.8V82.5h4.2c1.5,0,2.7,0.3,3.5,0.9c0.8,0.6,1.2,1.6,1.2,2.8c0,0.7-0.2,1.4-0.6,1.9c-0.4,0.5-1,0.9-1.7,1.1
                                c0.9,0.2,1.6,0.6,2.1,1.2c0.5,0.7,0.8,1.4,0.8,2.3c0,1.3-0.4,2.3-1.2,3c-0.8,0.7-1.9,1-3.3,1H76.5z M77.6,88.9h3.3
                                c1,0,1.8-0.2,2.4-0.7c0.6-0.5,0.9-1.1,0.9-2c0-0.9-0.3-1.6-0.9-2c-0.6-0.5-1.5-0.7-2.6-0.7h-3V88.9z M77.6,89.9v5.9h3.8
                                c1.1,0,1.9-0.3,2.5-0.8c0.6-0.5,0.9-1.2,0.9-2.2c0-0.9-0.3-1.6-0.8-2.1c-0.5-0.5-1.3-0.8-2.4-0.8H77.6z"/>
                            <path d="M97,89.9h-6.9v5.9H98v1H89V82.5h9v1h-7.9v5.4H97V89.9z"/>
                            <path d="M108.7,89.9h-6.9v5.9h7.9v1h-9.1V82.5h9v1h-7.9v5.4h6.9V89.9z"/>
                            <path d="M127,92.4L127,92.4c-0.1,1.5-0.6,2.6-1.5,3.5c-0.9,0.8-2.1,1.2-3.6,1.2c-1.6,0-2.9-0.6-3.9-1.7c-1-1.2-1.5-2.6-1.5-4.5
                                v-2.3c0-1.8,0.5-3.3,1.5-4.5c1-1.2,2.3-1.7,3.9-1.7c1.5,0,2.7,0.4,3.6,1.2c0.9,0.8,1.4,1.9,1.5,3.4l0,0.1h-1.1
                                c-0.2-1.2-0.6-2.1-1.2-2.7c-0.7-0.6-1.6-0.9-2.8-0.9c-1.3,0-2.3,0.5-3,1.5c-0.8,1-1.1,2.2-1.1,3.7v2.4c0,1.5,0.4,2.8,1.1,3.8
                                c0.8,1,1.8,1.5,3,1.5c1.2,0,2.1-0.3,2.8-0.9c0.7-0.6,1.1-1.5,1.2-2.8H127z"/>
                            <path d="M140.5,90.8c0,1.9-0.5,3.3-1.5,4.5c-1,1.1-2.4,1.7-4.1,1.7c-1.7,0-3-0.6-4-1.7c-1-1.1-1.5-2.6-1.5-4.5v-2.3
                                c0-1.8,0.5-3.3,1.5-4.5c1-1.1,2.3-1.7,4-1.7c1.7,0,3.1,0.6,4.1,1.7c1,1.1,1.5,2.6,1.5,4.5V90.8z M139.3,88.5
                                c0-1.6-0.4-2.8-1.2-3.7c-0.8-0.9-1.9-1.4-3.3-1.4c-1.4,0-2.4,0.5-3.2,1.4c-0.8,0.9-1.1,2.2-1.1,3.7v2.4c0,1.6,0.4,2.8,1.1,3.8
                                c0.8,0.9,1.8,1.4,3.2,1.4c1.4,0,2.5-0.5,3.3-1.4c0.8-0.9,1.2-2.2,1.2-3.8V88.5z"/>
                            <path d="M143.6,96.8V82.5h4.2c1.8,0,3.2,0.6,4.3,1.8c1.1,1.2,1.7,2.7,1.7,4.5v1.8c0,1.8-0.6,3.3-1.7,4.5c-1.1,1.2-2.6,1.7-4.3,1.7
                                H143.6z M144.8,83.5v12.3h3c1.4,0,2.6-0.5,3.5-1.5c0.9-1,1.4-2.2,1.4-3.8v-1.9c0-1.5-0.5-2.7-1.4-3.7c-0.9-1-2.1-1.5-3.5-1.5
                                H144.8z"/>
                            <path d="M164.9,89.9H158v5.9h7.9v1h-9.1V82.5h9v1H158v5.4h6.9V89.9z"/>
                            <path d="M168.5,96.8V82.5h4.2c1.8,0,3.2,0.6,4.3,1.8c1.1,1.2,1.7,2.7,1.7,4.5v1.8c0,1.8-0.6,3.3-1.7,4.5c-1.1,1.2-2.6,1.7-4.3,1.7
                                H168.5z M169.7,83.5v12.3h3c1.4,0,2.6-0.5,3.5-1.5c0.9-1,1.4-2.2,1.4-3.8v-1.9c0-1.5-0.5-2.7-1.4-3.7c-0.9-1-2.1-1.5-3.5-1.5
                                H169.7z"/>
                        </g>
                    </g>
                </svg>
            </div>
            <h1 class="text-center w-full dark:text-yellow-300">CMS Boilerplate</h1>
            <div class="flex justify-end mt-4 sm:items-center sm:justify-end">
                <div class="ml-4 text-center text-sm text-gray-500 sm:text-right sm:ml-0">
                    Laravel v{{ laravelVersion }} (PHP v{{ phpVersion }})
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>
import {defineComponent} from 'vue'
import {Head, Link} from '@inertiajs/inertia-vue3';

export default defineComponent({
    components: {
        Head,
        Link,
    },

    props: {
        canLogin: Boolean,
        canRegister: Boolean,
        laravelVersion: String,
        phpVersion: String,
    },
    mounted() {
        // console.log(this.dark)
    }
})
</script>
